import { useState } from "react";
import { Navigation, type Page } from "@/components/Navigation";
import { Dashboard } from "@/components/Dashboard";
import { PoolList } from "@/components/PoolList";
import { PoolDetail } from "@/components/PoolDetail";
import { Wallet } from "@/components/Wallet";
import { Referrals } from "@/components/Referrals";
import { Profile } from "@/components/Profile";
import type { Lang } from "@/lib/i18n";
import "./index.css";

export function App() {
  const [page, setPage] = useState<Page>("dashboard");
  const [lang, setLang] = useState<Lang>("ru");
  const [selectedPoolId, setSelectedPoolId] = useState<string | null>(null);

  const handleNavigate = (newPage: Page) => {
    setPage(newPage);
    setSelectedPoolId(null);
  };

  const handleSelectPool = (id: string) => {
    setSelectedPoolId(id);
    setPage("pools");
  };

  const renderPage = () => {
    if (page === "pools" && selectedPoolId) {
      return (
        <PoolDetail
          poolId={selectedPoolId}
          lang={lang}
          onBack={() => setSelectedPoolId(null)}
        />
      );
    }

    switch (page) {
      case "dashboard":
        return (
          <Dashboard
            lang={lang}
            onNavigateToPool={handleSelectPool}
            onNavigateToPools={() => setPage("pools")}
          />
        );
      case "pools":
        return <PoolList lang={lang} onSelectPool={handleSelectPool} />;
      case "wallet":
        return <Wallet lang={lang} />;
      case "referrals":
        return <Referrals lang={lang} />;
      case "profile":
        return <Profile lang={lang} onLangChange={setLang} onNavigateToReferrals={() => setPage("referrals")} />;
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Top header bar */}
      <header className="fixed top-0 left-0 right-0 z-50" style={{ background: "rgba(0, 0, 0, 0.88)", backdropFilter: "blur(20px) saturate(1.1)", WebkitBackdropFilter: "blur(20px) saturate(1.1)", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
        <div className="max-w-lg mx-auto flex items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center relative overflow-hidden" style={{ background: "#dc2626" }}>
              <span className="font-display text-[9px] font-black text-white tracking-tight relative z-10">GNK</span>
            </div>
            <div className="flex items-baseline gap-1">
              <span className="font-display text-[13px] font-black tracking-wider text-foreground">GONKA</span>
              <span className="font-display text-[10px] font-medium tracking-widest text-muted-foreground/50">POOL</span>
            </div>
          </div>
        </div>
      </header>

      {/* Main content area */}
      <main className="max-w-lg mx-auto px-5 pt-16 pb-24">
        {renderPage()}
      </main>

      {/* Bottom navigation */}
      <Navigation activePage={page} onNavigate={handleNavigate} lang={lang} />
    </div>
  );
}

export default App;
